/* KEPELO — interacciones propias (sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.kp-reveal:not(.kp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('[data-kp-comparador]').forEach(function (box) {
      var input = box.querySelector('input[type=range]');
      if (!input || input.dataset.kpListo) return;
      input.dataset.kpListo = '1';
      var set = function () { box.style.setProperty('--kp-pos', input.value + '%'); };
      input.addEventListener('input', set);
      set();
    });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-kp-cifra]');
    if (!els.length) return;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-kp-cifra')) || 0;
      var suf = el.getAttribute('data-kp-sufijo') || '';
      if (reduce) { el.textContent = fin + suf; return; }
      var t0 = null, dur = 1600;
      var paso = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v + suf;
        if (p < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-kp-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('.kp-galeria__principal img');
      if (!principal) return;
      gal.querySelectorAll('[data-kp-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-kp-src');
            principal.removeAttribute('srcset');
            principal.alt = btn.getAttribute('data-kp-alt') || '';
            principal.style.opacity = 1;
          }, 180);
          gal.querySelectorAll('[data-kp-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function formatoPrecio(centimos, formato) {
    var euros = (centimos / 100).toFixed(2);
    var conComa = euros.replace('.', ',');
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount\s*\}\}/, euros)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(centimos / 100));
  }

  function initProducto() {
    document.querySelectorAll('[data-kp-producto]').forEach(function (root) {
      var datos = root.querySelector('[data-kp-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name=id]');
      var btn = form.querySelector('[data-kp-anadir]');
      var precioEl = root.querySelector('[data-kp-precio]');
      var tachadoEl = root.querySelector('[data-kp-tachado]');
      var ahorroEl = root.querySelector('[data-kp-ahorro]');
      var errorEl = root.querySelector('[data-kp-error]');
      var formato = root.getAttribute('data-kp-formato');
      var txtAnadir = btn ? btn.getAttribute('data-kp-txt') : '';
      var txtAgotado = btn ? btn.getAttribute('data-kp-agotado') : '';

      // Cantidad
      var qty = root.querySelector('[data-kp-cantidad]');
      if (qty) {
        root.querySelectorAll('[data-kp-qty]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-kp-qty'), 10);
            qty.value = Math.max(1, v);
          });
        });
      }

      // Variantes
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        var actualizar = function () {
          var sel = [];
          root.querySelectorAll('[data-kp-opcion]').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === sel[i]; });
          });
          if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = txtAgotado; } return; }
          idInput.value = v.id;
          if (precioEl) precioEl.textContent = formatoPrecio(v.price, formato);
          if (tachadoEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              tachadoEl.textContent = formatoPrecio(v.compare_at_price, formato); tachadoEl.hidden = false;
              if (ahorroEl) { ahorroEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; ahorroEl.hidden = false; }
            } else { tachadoEl.hidden = true; if (ahorroEl) ahorroEl.hidden = true; }
          }
          if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? txtAnadir : txtAgotado; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        };
        root.querySelectorAll('[data-kp-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });
      }

      // Añadir al carrito sin salir de la página (abre el carrito de Dawn si existe)
      form.addEventListener('submit', function (ev) {
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        ev.preventDefault();
        if (errorEl) errorEl.hidden = true;
        btn && btn.setAttribute('aria-busy', 'true');
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          btn && btn.removeAttribute('aria-busy');
          if (res.status) { if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; } return; }
          drawer.renderContents(res);
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        }).catch(function () { btn && btn.removeAttribute('aria-busy'); form.submit(); });
      });

      // Barra fija en móvil
      var barra = root.querySelector('[data-kp-barra]');
      if (barra && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var debajo = e.boundingClientRect.top < 0;
            barra.classList.toggle('kp-visible', !e.isIntersecting && debajo);
          });
        }).observe(btn);
        var irBtn = barra.querySelector('button');
        if (irBtn) irBtn.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }

  function initTodo() { initReveal(); initComparador(); initCifras(); initGaleria(); initProducto(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', function () { initReveal(); initComparador(); initCifras(); initGaleria(); });
})();
